/**
 * Return a unique string template for all subtitles
 *
 * @export
 * @function
 * @param {Object[]} subtitles Array of Object subtitle
 * @param {string} subtitles.poste
 * @param {string} subtitles.entreprise
 * @returns {String}
 */
export let cardThumbnailSubtitlesTpl = function(subtitles) {
    return subtitles.map((objectElem)=>{
        let entreprise = '';
        if (objectElem.entreprise) {
            entreprise = ', ' + objectElem.entreprise;
        }
        return `<p class="h5 card-thumbnail-details__subtitle">${objectElem.poste}${entreprise}</p>`;
    }).join('');
};

/**
 * Return a imageHd download btn if an image HD exist
 *
 * @export
 * @function
 * @param {String} imageHD
 * @param {String} btnLabel
 * @param {String} imageSize
 */
export let cardThumbnailImageHdTpl = function(imageHD, btnLabel, imageSize) {
    const tpl = `<a class="btn btn--icon card-thumbnail-details__btn" 
                        download target="_blank" href="${imageHD}">
                       <svg class="ico ico--download"><use xlink:href="#download"/></svg>
                       ${btnLabel} (${imageSize})
                    </a>`;
    return (imageHD !== '') ? tpl : '';
};

/**
 * Return a string template of card-thumbnail-details for lightbox
 *
 * @export
 * @function
 * @param {Object} data Contain all content info
 * @param {String} data.image Image HTML
 * @param {String} data.imageHD Image HD url
 * @param {String} data.imageSize Image size
 * @param {String} data.btnlabel Download button label
 * @param {String} data.title Title
 * @param {Array} data.subtitles subtitle
 * @param {String} data.description description
 * @return {String}
 */
export let cardThumbnailTpl = function(data) {
    return `<div class="card-thumbnail-details container">
                <aside class="card-thumbnail-details__picture">
                    ${data.image}
                    ${cardThumbnailImageHdTpl(data.imageHD, data.btnlabel, data.imageSize)}
                </aside>
                <article class="content-zone card-thumbnail-details__text">
                    <h1 class="card-thumbnail-details__title"> ${data.title} </h1>
                    <div class="card-thumbnail-details__subtitles">
                    ${cardThumbnailSubtitlesTpl(data.subtitles)}
                    </div>
                    ${data.description}
                </article>
            </div>`;
};



// WEBPACK FOOTER //
// ./src/main/js/templates/cardThumbnailTpl.js